package fyi.moko.hotpl.domain.service

/** Thrown by a [PlaceSearchProvider] implementation when a remote call fails or a
 * requested place id isn't recognized (e.g. a non-2xx HTTP status, or a lookup that
 * found no match). [FallbackPlaceSearchProvider] relies on this being the signal for
 * "try the other provider" — implementations should throw it rather than a more
 * specific/opaque exception type for failures that should trigger that fallback. */
class PlaceSearchException(message: String) : Exception(message)
